import React, { useState } from 'react';
import {
  Box,
  useTheme,
  IconButton
} from '@mui/material';

import { useAccessState } from 'modules/common';
import { CustomIcon } from 'modules/components/layer00';
import { ActivityDetailSectionCardBaseLayout } from 'modules/components/layer16';
import { SaveMetaPhotoModal } from 'modules/components/layer17';
import * as ds from './dataService';


export type ClientReportPhotoCardProps = {
  id: string;
  photos: { id: string; url: string; included: boolean }[];
};

export const FC = (props: ClientReportPhotoCardProps) => {
  const theme = useTheme();
  const [
    isVisible,
    setIsVisible
  ] = useState(false);

  const [fnSavePhoto] = ds.useSaveClientReportPhoto();

  const access = useAccessState('MetaPhoto');

  return (
    <>
      {isVisible && (
        <SaveMetaPhotoModal.FC
          id=''
          isVisible={isVisible}
          handleClose={() => setIsVisible(() => false)}
        />
      )}
      <ActivityDetailSectionCardBaseLayout.FC
        title='Daily Report Photos'
        isEmpty={false}
        subTitle='Photos from daily reports'
        actionButton={null}
        editActionButton={null}
      >
        <Box
          display='flex'
          flexDirection='row'
          flexWrap='wrap'
          gap='1rem'
        >
          {props.photos.map((node) => (
            <Box
              key={node.id}
              position='relative'
            >
              <IconButton
                disabled={!access.update}
                onClick={async () => {
                  await fnSavePhoto({
                    id: node.id,
                    included: !node.included
                  });
                }}
                sx={{
                  bgcolor: node.included
                    ? theme.palette.primary.main
                    : theme.palette.error.main,
                  position: 'absolute',
                  height: '1.5rem',
                  width: '1.5rem',
                  left: '-.75rem',
                  top: '-.5rem'
                }}
              >
                <CustomIcon.large.FC
                  icon={node.included ? 'CHECKFLAT' : 'CLOSE'}
                  stroke={theme.palette.error.contrastText}
                />
              </IconButton>
              <Box
                sx={{
                  opacity: node.included ? 1 : 0.25
                }}
                component='img'
                src={node.url}
                borderRadius='1rem'
                width='8rem'
                height='8rem'
              />
            </Box>
          ))}
        </Box>

      </ActivityDetailSectionCardBaseLayout.FC>
    </>

  );
};
